<h1 mat-dialog-title i18n>Manage SIS Roles <small class="align-top">- {{dialogData.user.email}}</small></h1>

<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div mat-dialog-content class="main-content">
		<div class="row">

			<div class="col-12">
				<mat-form-field appearance="standard" class="w-100">
					<mat-label i18n>Add Role</mat-label>
					<mat-select class="cluster-selector" formControlName="roleToAdd" (selectionChange)="addRole($event.value)" cdkFocusInitial>
						<mat-option
							*ngFor="let r of filteredRolesToAdd"
							[value]="r"
							[innerHtml]="r"
						></mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="col-12 mb-3">
				<mat-chip-list #chipList aria-label="User Roles">
					<mat-chip
						color="primary"
						*ngFor="let r of userRoles"
						(removed)="removeRole(r)"
						title="Remove Role"
						[disabled]="!availableRolesToRemove.includes(r)"
					>
						{{r}}
						<mat-icon *ngIf="availableRolesToRemove.includes(r)" matChipRemove>cancel</mat-icon>
					</mat-chip>
				</mat-chip-list>
			</div>

			<div class="col-12 mb-3" *ngIf="canTroubleshootRoles">
				<button
					type="button"
					mat-stroked-button
					class="w-100"
					(click)="toggleRoleSources()"
				>
					<span *ngIf="!showRoleSources" i18n>Troubleshoot Roles (View Sources)</span>
					<span *ngIf="showRoleSources" i18n>Hide Role Sources</span>
				</button>
			</div>

			<div class="col-12 mb-3" *ngIf="canTroubleshootRoles && showRoleSources">
				<app-users-roles-sources-dialog
					#roleSourcesDialog
					[embedded]="true"
					[dialogData]="{ user: dialogData.user }"
				></app-users-roles-sources-dialog>
			</div>
		</div>
	</div>

	<div mat-dialog-actions class="row mb-0">
		<div class="col-4 text-center">
			<button
				class="w-100"
				mat-flat-button
				(click)="closeDialog()"
				i18n
				type="button"
			>Cancel</button>
		</div>
		<div class="col-4 text-center">
			<button
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				(click)="setCloseAfterSubmit(false)"
				[disabled]="formInputs.invalid"
				i18n
			>Apply</button>
		</div>
		<div class="col-4 text-center">
			<button
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				(click)="setCloseAfterSubmit(true)"
				[disabled]="formInputs.invalid"
				i18n
			>Apply and Close</button>
		</div>
	</div>
</form>
